import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { UserAvatar } from "components/Atoms/Avatar";
import moment from "moment";
import SubLabel from "components/Atoms/Sublabel";
import { formatWrittenDayMonthYear } from "utilities";
import { useLoaderData } from "react-router";

const UserActionList = () => {
  const viewModel = useLoaderData<server.viewmodel.UserActionListFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet="userActionLog_List"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        fetchFunction={window.CoreApi.UserAction.List}
        getId={item => item.userActionId}
        layout={{
          type: "table",
          hideHeader: true,
          columns: [
            {
              header: "",
              key: "avatar",
              size: "1fr",
              render: item => <div className="flex gap" title={formatWrittenDayMonthYear(item.createdUtc)}>
                <div>
                  <UserAvatar user={item.user} size="avatar" />
                </div>
                <div>
                  <div>{item.message}</div>
                  <SubLabel small>{moment.utc(item.createdUtc).fromNow()}</SubLabel>
                </div>
              </div>
            }, {
              header: "IP",
              key: "ipAddress",
              size: "auto",
              render: item => <>IP: {item.remoteAddress}</>
            }

          ]
        }}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction
        }}
      />
    </TwoColumnLayout.LeftColumn>
  </TwoColumnLayout>
};


export default UserActionList;